export default __webpack_public_path__ + "static/media/sharelinkw.88dce9d4.svg";